module.exports = __webpack_public_path__ + "img/skip-truck.632eb59.png";